import React, { FC, useState, useContext } from 'react';
import RadioButtonList from 'Components/RadioButtonList';
import SmartList from 'Components/SmartList';
import injectSheet from 'react-jss';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import withErrorBoundary from 'HOC/ErrorBoundary';
import styleSheet from './styles';

interface Props {
  checkedItems?: any;
  userIds?: any[];
  fromListId?: string;
  closeModal?: () => void;
  openDefault?: 'create' | 'existing';
  filters?: any;
  searchText?: string;
}

const SelectList: FC<Props> = (props: Props) => {
  const {
    checkedItems,
    userIds,
    fromListId,
    closeModal,
    openDefault,
    filters,
    searchText,
  } = props;
  const [selectedOption, setSelectedOption] = useState(openDefault);

  const options = {
    list: [
      {
        id: 'Select List Type - Existing',
        value: 'existing',
        label: 'Existing List',
      },
      {
        id: 'Select List Type - Create',
        value: 'create',
        label: 'Create New',
      },
    ],
  };
  useContext(ProductAnalyticsContext);
  const onChange = (e: any) => {
    setSelectedOption(e.target.value);
  };
  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <RadioButtonList
          direction="row"
          justify="center"
          field={options}
          onChange={onChange}
          selectedValue={selectedOption}
        />
      </div>
      {selectedOption === 'create' && (
        <SmartList.New
          checkedItems={checkedItems}
          userIds={userIds}
          filters={filters}
          closeModal={closeModal}
          fromListId={fromListId}
          searchText={searchText}
        />
      )}
      {selectedOption === 'existing' && fromListId === '-1' && (
        <SmartList.Add
          checkedItems={checkedItems}
          userIds={userIds}
          closeModal={closeModal}
          filters={filters}
          searchText={searchText}
        />
      )}
      {selectedOption === 'existing' && fromListId !== '-1' && (
        <SmartList.ExistingIndividualList
          checkedItems={checkedItems}
          userIds={userIds}
          closeModal={closeModal}
          fromListId={fromListId}
          searchText={searchText}
        />
      )}
    </div>
  );
};

SelectList.defaultProps = {
  checkedItems: undefined,
  fromListId: '',
  closeModal: () => {},
  openDefault: 'existing',
  userIds: [],
  filters: undefined,
  searchText: '',
};

export default withErrorBoundary(injectSheet(styleSheet)(SelectList));
